// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3GfG3","inputWrap":"CustomTip_inputWrap__3Eb3H"};